import { render } from "./ViewMoreDetails.vue?vue&type=template&id=2ecaee7a"
import script from "./ViewMoreDetails.vue?vue&type=script&lang=js"
export * from "./ViewMoreDetails.vue?vue&type=script&lang=js"

import "./ViewMoreDetails.vue?vue&type=style&index=0&id=2ecaee7a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__